import { render, staticRenderFns } from "./ProductCosts.vue?vue&type=template&id=63b121d6&scoped=true"
import script from "./ProductCosts.vue?vue&type=script&lang=js"
export * from "./ProductCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b121d6",
  null
  
)

export default component.exports